var _rect, _rect2, _rect3, _circle, _rect4, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddPhonenumberBtnIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "AddPhoneNumber_Outline_24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1002",
    width: 24,
    height: 24,
    fill: "#165cf3",
    opacity: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_986",
    width: 22,
    height: 22,
    transform: "translate(0.94 1)",
    fill: "none"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1172",
    "data-name": "Rectangle 1172",
    width: 22,
    height: 22,
    transform: "translate(0.83 1)",
    opacity: 0
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_176",
    "data-name": "Ellipse 176",
    cx: 0.57,
    cy: 0.57,
    r: 0.57,
    transform: "translate(5.92 17.33)",
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_986-2",
    width: 22,
    height: 22,
    transform: "translate(0.83 1)",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "phone1",
    d: "M8.32,19.32a15.567,15.567,0,0,0,9.13,2.94H19.8a2.347,2.347,0,0,0,2.35-2.35h0V18.48a1.177,1.177,0,0,0-.89-1.14l-4.62-1.15a1.184,1.184,0,0,0-1.22.43l-1.01,1.35a1.105,1.105,0,0,1-1.26.4A12.554,12.554,0,0,1,5.7,10.92a1.1,1.1,0,0,1,.4-1.26L7.45,8.65a1.155,1.155,0,0,0,.43-1.22L6.72,2.81a1.177,1.177,0,0,0-1.14-.89H4.15A2.347,2.347,0,0,0,1.8,4.27h0V6.62a15.55,15.55,0,0,0,3.28,9.59",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "add-circle",
    d: "M14.88,4.82a4.5,4.5,0,1,0,4.5,4.5,4.494,4.494,0,0,0-4.5-4.5Zm1.73,4.85H15.23v1.38a.35.35,0,1,1-.7,0V9.67H13.15a.35.35,0,0,1,0-.7h1.38V7.59a.35.35,0,0,1,.7,0V8.97h1.38a.35.35,0,0,1,0,.7Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPhonenumberBtnIcon);
export default __webpack_public_path__ + "static/media/add-phonenumber-btn-icon.52037f955207e1718b4d99a47cfcc495.svg";
export { ForwardRef as ReactComponent };